import { z } from 'zod';
import { exampleUser, User } from '../user';

export const commentAnchorTypeSchema = z.enum([
  'section',
  'narrative-block',
  'performance-metric',
  'creative',
]);

export type CommentAnchorType = z.infer<typeof commentAnchorTypeSchema>;

export interface Comment {
  id: number;
  anchorType: CommentAnchorType;
  // Stringified entity ID (e.g. creative ID) or packet-scoped key like "<packetID>:<sectionKey>".
  anchorID: string;
  parentCommentID: number | null;
  // Null when the author has been deleted — preserves audit trail.
  author: User | null;
  body: string;
  resolved: boolean;
  createdAt: string;
  updatedAt: string;
}

export const exampleComment: Comment = {
  id: 1,
  anchorType: 'creative',
  anchorID: '1',
  parentCommentID: null,
  author: exampleUser,
  body: 'hello',
  resolved: false,
  createdAt: new Date(0).toISOString(),
  updatedAt: new Date(0).toISOString(),
};

export const CreateCommentDTO = z.object({
  anchorType: commentAnchorTypeSchema,
  anchorID: z.string().min(1).max(128),
  parentCommentID: z.number().nullish(),
  body: z.string().min(1),
  taggedUserIDs: z.array(z.number()).optional(),
});

export type CreateComment = z.infer<typeof CreateCommentDTO>;

export const UpdateCommentDTO = z.object({
  body: z.string().min(1).optional(),
  resolved: z.boolean().optional(),
});

export type UpdateComment = z.infer<typeof UpdateCommentDTO>;
